import(/* webpackMode: "eager" */ "/work/apps/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/work/apps/frontend/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["bindGtmUser","trackAddToCart","trackBeginCheckout","trackClickSubmitRefund","trackPurchase","trackSignUp","trackViewBrand","trackViewItem"] */ "/work/apps/frontend/src/shared/analytics/events.ts");
;
import(/* webpackMode: "eager", webpackExports: ["MixpanelProvider"] */ "/work/apps/frontend/src/shared/analytics/MixpanelProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApiProvider"] */ "/work/apps/frontend/src/shared/api/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/work/apps/frontend/src/shared/auth/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChannelTalkProvider"] */ "/work/apps/frontend/src/shared/channel-talk/ChannelTalkProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogClient"] */ "/work/apps/frontend/src/shared/logging/LogClient.tsx");
;
import(/* webpackMode: "eager" */ "/work/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/work/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/work/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/work/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/work/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-heading\",\"display\":\"swap\"}],\"variableName\":\"montserrat\"}");
